import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class GenerateReportForm extends BaseComponent {
	
	static get properties() {
		return {
			scheduled: {type: Boolean},
			options: {type: String}
		};
	}
	
	constructor() {
		super();
				
		this.scheduled = false;	
		this.options = '';
				
		var generateForm = this;
		setTimeout(function(){
			generateForm.init();
		});
	}
	
	render() {	
		return html`
			<style>
				:host {
					display: block;
					height: 100%;
				}
				.fill {
					height: 100%;
				}
			</style>
			<div><slot name="top"></slot></div>
			<div class="fill"><slot name="container"></slot></div>			
			<div><slot name="buttons"></slot></div>
		`;
	}
	
	init() {
		var generateForm = this;
		if (generateForm.options) {
			generateForm.options = JSON.parse(generateForm.options);
		} else {
			generateForm.options = {};
		}
		
		var allReportDefs = [];
		var reportContainer;
		var optionsWin = null;
		
		var saveButtonText = function() {
			if (generateForm.options.saveText) {
				return generateForm.options.saveText;
			} else {
				return (generateForm.scheduled ? 'Schedule' : ' Generate');
			}
		};
		
		var closeOptionsDialog = function() {
			if (optionsWin) {
				var win = optionsWin;
				optionsWin = null;
				win.close();
			}
		};
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [
				{
					tag: 'vaadin-combo-box',
					itemid: 'filterCategory',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					'clear-button-visible': true,
					label: 'Filter By Category',
					placeHolder: 'Select',
					listeners: {
						change: function() {
							filterResults();
						}
					}
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'filterReportType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					'clear-button-visible': true,
					label: 'Filter By Report Type',
					placeHolder: 'Select',
					listeners: {
						change: function() {
							filterResults();
						}
					}
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'unitGroup',
					'class': 'spacer-toolbar-item',
					style: 'width: 200px;',
					label: 'Unit Group',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'clear-button-visible': true,
					placeHolder: 'Select',
					listeners: {
						change: function() {
							generateForm.groupSelected = ElementUtil.query(toolbarFilter, 'unitGroup').selectedItem;
							loadReportDefinitions();
						}
					}
				}
			]
		});
		
		var reportGrid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [
				{						
					path: 'category',
					header: 'Category',
					width: '5em'
				},
				{						
					path: 'reportTypeDescription',
					header: 'Type',
					width: '7em'
				},
				{						
					path: 'description',
					header: 'Description',
					width: '12em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					reportGrid.selectedItems = item ? [item] : [];

					if (reportGrid.selectedItems.length > 0) {					  
						ElementUtil.query(selectionButtons, 'selectbtn').disabled = false;												
					} else {						
						ElementUtil.query(selectionButtons, 'selectbtn').disabled = true;
					}
				}
			}
		});
		
		var selectionButtons = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'footer',
			theme: 'spacing',
			children: [
				{
					tag: 'div',
					style: 'text-align: center; width: 100%;',
					children: [
						{
							tag: 'vaadin-button',
							itemid: 'selectbtn',
							theme: 'primary',
							disabled: true,
							children: [
								ElementUtil.makeIcon('vaadin:check', ' Select')
							],
							listeners: {
								click: function() {
									handleReportSelect(reportGrid.selectedItems[0]);
								}
							}
						},
						{
							tag: 'vaadin-button',
							theme: 'tertiary',
							innerHTML: 'Cancel',
							style: 'margin-left: 10px;',
							listeners: {
								click: function() {
									var cancelEvent = new CustomEvent('cancel', { detail: '' });
									generateForm.dispatchEvent(cancelEvent);
								}
							}
						}
					]
				}
			]
		});
		
		var selectionLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			slot: 'container',
			style: 'height: 100%; min-height: 400px;',
			children: [
				toolbarFilter,
				reportGrid,
				selectionButtons
			]
		});
		
		generateForm.append(selectionLayout);
		
		var filterResults = function() {
			var reportFilter = ElementUtil.query(toolbarFilter, 'filterReportType').value;
			var categoryFilter = ElementUtil.query(toolbarFilter, 'filterCategory').value;
			
			var keepList = [];
			allReportDefs.forEach(function(item){
				var keep = true;
				if (reportFilter && reportFilter !== '') {
					if (item.reportTypeDescription !== reportFilter) {
						keep = false;
					}
				}
				
				if (categoryFilter && categoryFilter !== '') {
					if (item.category !== categoryFilter) {
						keep = false;
					}
				}
				
				if (keep) {
					keepList.push(item);
				}
			});							
			loadReportTypes(keepList);
		};
		
		var loadReportTypes = function(data) {
			reportGrid.activeItem = null;
			reportGrid.selectedItems = [];
			reportGrid.items = data.slice(0);
			ElementUtil.query(selectionButtons, 'selectbtn').disabled = true;
		};
		
		var populateFilterOptions = function(data) {
			var categories = [];
			var reportTypes = [];
			var categorySeen = {};
			var reportTypeSeen = {};
			
			data.forEach(function(item) {
				if (item.category && !categorySeen[item.category]) {
					categorySeen[item.category] = true;
					categories.push(item.category);
				}
				if (item.reportTypeDescription && !reportTypeSeen[item.reportTypeDescription]) {
					reportTypeSeen[item.reportTypeDescription] = true;
					reportTypes.push(item.reportTypeDescription);
				}
			});
			
			categories.sort(function(a, b) {
				return a.localeCompare(b);
			});
			reportTypes.sort(function(a, b) {
				return a.localeCompare(b);
			});
			
			var categoryCombo = ElementUtil.query(toolbarFilter, 'filterCategory');
			var reportTypeCombo = ElementUtil.query(toolbarFilter, 'filterReportType');
			var previousCategory = categoryCombo.value;
			var previousReportType = reportTypeCombo.value;
			
			categoryCombo.items = categories;
			reportTypeCombo.items = reportTypes;
			
			// Keep Category / Report Type when still available for the new unit group
			categoryCombo.value = (previousCategory && categorySeen[previousCategory]) ? previousCategory : null;
			reportTypeCombo.value = (previousReportType && reportTypeSeen[previousReportType]) ? previousReportType : null;
		};
		
		var loadReportDefinitions = function() {
			var groupId = null;
			if (generateForm.groupSelected) {
				groupId = generateForm.groupSelected.code;
			}
			
			var loadMask = reportGrid.showLoading ? reportGrid.showLoading() : null;
			Service.getReportService().getReportDefinitions(generateForm.companyId, groupId).then(function(data){
				if (loadMask) {
					loadMask.remove();
				}
				data.sort(function(a,b) {
					return a.category.localeCompare(b.category);	
				});
				
				allReportDefs = data.slice(0);
				populateFilterOptions(allReportDefs);
				filterResults();
			}, function() {
				if (loadMask) {
					loadMask.remove();
				}
			});
		};
		
		generateForm.loadUnitGroups = function() {
			var unitGroupCombo = ElementUtil.query(toolbarFilter, 'unitGroup');
			if (!unitGroupCombo) {
				return;
			}
			UnitService.getUnitLookupService().getUnitGroups(generateForm.companyId).then(function(data) {
				unitGroupCombo.items = data;
			});
		};
		
		generateForm.reloadReportSelection = function() {
			generateForm.loadUnitGroups();
			loadReportDefinitions();
		};
		
		generateForm.loadUnitGroups();
		loadReportDefinitions();
		
		var createOptionButtons = function() {
			return ElementUtil.create({			
				tag: 'vaadin-form-layout',
				children: [											
					{
						tag: 'hr',
						colspan: 2
					},
					{
						tag: 'div',
						style: 'text-align: center;',
						colspan: 2,
						defaults: {
							tag: 'vaadin-button'
						},
						children: [
							{
								theme: 'primary',
								children: [
									ElementUtil.makeIcon('vaadin:cogs', saveButtonText())
								],
								listeners: {
									click: function() {																		
										
										//verify there is at least one output
										if (reportContainer.outputs.length === 0) {
											window.DL.MessageUtil.showToastError('Must have at least one output.', 'Validation');										
										} else {									
											
											var selectedReport = generateForm.selectedReport;										
											var reportSubmission = {
												reportType: selectedReport.reportType,
												reportTypeDescription: selectedReport.reportTypeDescription,
												customUnitSelection: []
											};
																		
											var unitSelection;
											var unitSelectionCB = ElementUtil.query(reportContainer, 'unitSelection');
											if (unitSelectionCB) {
												unitSelection = ElementUtil.query(reportContainer, 'unitSelection').unitSelectionValue();
											}
											
											if (unitSelection && (selectedReport.applicableReferenceTypes && selectedReport.applicableReferenceTypes.length > 0)) {
												reportSubmission.unitSelectionType = unitSelection.type;
												if (unitSelection.groupId) {
													reportSubmission.unitGroupId = unitSelection.groupId;
												}
												if (unitSelection.groupTagExpression) {
													reportSubmission.groupTagExpression = unitSelection.groupTagExpression;
												}
												if (unitSelection.bulkGroupConfig) {
													reportSubmission.bulkGroupConfig = unitSelection.bulkGroupConfig;
												}
												unitSelection.customList.forEach(function(item){
													reportSubmission.customUnitSelection.push({
														referenceType: item.referenceType,
														unitId: item.unitId,
														referenceNo: item.unitRefNo
													});
												});												
											}										

											if (generateForm.companyId) {
												reportSubmission.companyId = generateForm.companyId;
											}

											//gather data									
											var optionsForm = ElementUtil.query(reportContainer, 'reportOptionForm');									
											var generalForm = ElementUtil.query(reportContainer, 'generalForm');
											
											//put in stub
											if (!optionsForm) {
												optionsForm = {
													isValid: function() {
														return true;
													},
													getData: function() {
														return {};
													}
												};
											}
											
											if (optionsForm.isValid() && generalForm.isValid()) {

												var generalData = generalForm.getData();
												reportSubmission.note = generalData.note;

												var optionData = optionsForm.getData();
												
												if (optionData.reportBeginDts) {
													reportSubmission.reportBeginDts = optionData.reportBeginDts;
												}
												if (optionData.reportEndDts) {
													reportSubmission.reportEndDts = optionData.reportEndDts;
												}
												reportSubmission.options = {};
												for (var key in optionData) {
													
													if (key.startsWith('ymq_')) {
														var ymqData = optionData[key];
														if (ymqData.year != null && ymqData.year !== '') {
															reportSubmission.options['YEAR'] = '' + ymqData.year;
														}
														if (ymqData.month != null && ymqData.month !== '') {
															reportSubmission.options['MONTHLY'] = 'true';
															reportSubmission.options['MONTH'] = '' + ymqData.month;
														}
														if (ymqData.quarter != null && ymqData.quarter !== '') {
															reportSubmission.options['QUARTER'] = '' + ymqData.quarter;
														}
														var ymqDates = TimeUtil.resolveYearMonthQuarterDates(ymqData);
														if (ymqDates) {
															reportSubmission.reportBeginDts = ymqDates.begin;
															reportSubmission.reportEndDts = ymqDates.end;
														}
													} else if (key.startsWith('period_')) {
														var periodData = optionData[key];
														if (periodData && periodData.mode === 'DATE_RANGE') {
															if (periodData.startDate && periodData.endDate) {
																var startParts = periodData.startDate.split('-');
																var endParts = periodData.endDate.split('-');
																var rangeBegin = new Date(
																	parseInt(startParts[0], 10),
																	parseInt(startParts[1], 10) - 1,
																	parseInt(startParts[2], 10),
																	0, 0, 0, 0
																);
																var rangeEnd = new Date(
																	parseInt(endParts[0], 10),
																	parseInt(endParts[1], 10) - 1,
																	parseInt(endParts[2], 10),
																	23, 59, 59, 999
																);
																reportSubmission.reportBeginDts = rangeBegin.toISOString();
																reportSubmission.reportEndDts = rangeEnd.toISOString();
															}
														} else if (periodData) {
															if (periodData.year != null && periodData.year !== '') {
																reportSubmission.options['YEAR'] = '' + periodData.year;
															}
															if (periodData.month != null && periodData.month !== '') {
																reportSubmission.options['MONTHLY'] = 'true';
																reportSubmission.options['MONTH'] = '' + periodData.month;
															}
															if (periodData.quarter != null && periodData.quarter !== '') {
																reportSubmission.options['QUARTER'] = '' + periodData.quarter;
															}
															var periodDates = TimeUtil.resolveYearMonthQuarterDates(periodData);
															if (periodDates) {
																reportSubmission.reportBeginDts = periodDates.begin;
																reportSubmission.reportEndDts = periodDates.end;
															}
														}
													} else if (key.startsWith('mpgtype_')) {
														var mpgTypeData = optionData[key];
														if (mpgTypeData) {
															var mpgTargets = mpgTypeData.mpgOverrideTargets || {};

															reportSubmission.options['MPG_OVERRIDE_TYPE'] = mpgTypeData.type;
															if (mpgTypeData.mpgOverride != null && mpgTypeData.mpgOverride !== '') {
																reportSubmission.options['MPG_OVERRIDE'] = '' + mpgTypeData.mpgOverride;
															}

															if (mpgTargets.mpgMaxOverride != null && mpgTargets.mpgMaxOverride !== '') {
																reportSubmission.options['MPG_OVERRIDE_MAX'] = '' + mpgTargets.mpgMaxOverride;
															}
															if (mpgTargets.mpgMaxOverrideDefault != null && mpgTargets.mpgMaxOverrideDefault !== '') {
																reportSubmission.options['MPG_OVERRIDE_MAX_OVERRIDE'] = '' + mpgTargets.mpgMaxOverrideDefault;
															}
															if (mpgTargets.mpgMinOverride != null && mpgTargets.mpgMinOverride !== '') {
																reportSubmission.options['MPG_OVERRIDE_MIN'] = '' + mpgTargets.mpgMinOverride;
															}
															if (mpgTargets.mpgMinOverrideDefault != null && mpgTargets.mpgMinOverrideDefault !== '') {
																reportSubmission.options['MPG_OVERRIDE_MIN_OVERRIDE'] = '' + mpgTargets.mpgMinOverrideDefault;
															}
															if (mpgTargets.mpgBetweenMinOverride != null && mpgTargets.mpgBetweenMinOverride !== '') {
																reportSubmission.options['MPG_OVERRIDE_BETWEEN_MIN'] = '' + mpgTargets.mpgBetweenMinOverride;
															}
															if (mpgTargets.mpgBetweenMaxOverride != null && mpgTargets.mpgBetweenMaxOverride !== '') {
																reportSubmission.options['MPG_OVERRIDE_BETWEEN_MAX'] = '' + mpgTargets.mpgBetweenMaxOverride;
															}
															if (mpgTargets.mpgBetweenOverrideDefault != null && mpgTargets.mpgBetweenOverrideDefault !== '') {
																reportSubmission.options['MPG_OVERRIDE_BETWEEN_OVERRIDE'] = '' + mpgTargets.mpgBetweenOverrideDefault;
															}
														}
														
													} else if (key.startsWith('highlight_')) {
														var highlightData = optionData[key];
														if (highlightData) {
															if (highlightData.highlightMissingDistance) {
																reportSubmission.options['HIGHLIGHT_MISSING_DISTANCE'] = 'true';
															}
															if (highlightData.highlightMissingFuel) {
																reportSubmission.options['HIGHLIGHT_MISSING_FUEL'] = 'true';
															}
															if (highlightData.highlightOutsideRange) {
																reportSubmission.options['HIGHLIGHT_OUTSIDE_RANGE'] = 'true';
																if (highlightData.highlightRangeStart != null && highlightData.highlightRangeStart !== '') {
																	reportSubmission.options['HIGHLIGHT_RANGE_START'] = '' + highlightData.highlightRangeStart;
																}
																if (highlightData.highlightRangeEnd != null && highlightData.highlightRangeEnd !== '') {
																	reportSubmission.options['HIGHLIGHT_RANGE_END'] = '' + highlightData.highlightRangeEnd;
																}
															}
														}

													} else {						
														if (optionData[key] && optionData[key] !== 'null') {
															reportSubmission.options[key] = optionData[key];
														}
													}
												}

												reportSubmission.outputs = [];											
												reportContainer.outputs.forEach(function(output){
													var outputOptions = ElementUtil.query(reportContainer, 'reportOutputForm-' + output.outputId);	
													if (outputOptions.isValid()) {
														var outputOptionData = outputOptions.getData();

														var fullOutput = {
															transmissionType: output.transmissionType,
															format: outputOptionData.format,
															options: {}
														};

														for (var key in outputOptionData) {
															fullOutput.options[key] = outputOptionData[key];
														}											
														reportSubmission.outputs.push(fullOutput);
													}
												});
												//verify they are all valid
												if (reportSubmission.outputs.length === reportContainer.outputs.length) {
													if (generateForm.saveHandler) {
														closeOptionsDialog();
														generateForm.saveHandler(reportSubmission); 
													} else {
														if (generateForm.scheduled) {

															if (generalData.scheduleType === 'DAY') {
																reportSubmission.scheduleIntervalDays = 1;
															} else if (generalData.scheduleType === 'W') {
																reportSubmission.scheduleIntervalDays = 7;
															} else if (generalData.scheduleType === 'M') {
																reportSubmission.scheduleIntervalDays = 28;
															} else if (generalData.scheduleType === 'Q') {
																reportSubmission.scheduleIntervalDays = 84;
															} else if (generalData.scheduleType === 'Minutes') {
																reportSubmission.scheduleIntervalMinutes = generalData.minutes;
															} else if (generalData.scheduleType === 'C') {
																reportSubmission.scheduleIntervalCron = generalData.cron;
															}
															reportSubmission.reportDaysInPast = generalData.reportDaysInPast;

															delete reportSubmission.customUnitSelection;
															var scheduledSubmission = {
																scheduledReport: reportSubmission,
																customUnitSelection: []
															};

															//unit selection
															if ((selectedReport.applicableReferenceTypes && selectedReport.applicableReferenceTypes.length > 0) &&
																	unitSelection && unitSelection.customList) {
																unitSelection.customList.forEach(function (item) {
																	scheduledSubmission.customUnitSelection.push({
																		referenceType: item.referenceType,
																		unitId: item.unitId,
																		referenceNo: item.unitRefNo
																	});
																});
															}
															
															var scheduleLoadMask = optionsWin.showLoading();
															Service.getReportService().saveScheduleReport(scheduledSubmission, false).then(function (data) {
																scheduleLoadMask.remove();
																
																window.DL.MessageUtil.showToast('Success', 'Scheduled Report', {
																	theme: 'success'
																});
																closeOptionsDialog();
																var successEvent = new CustomEvent('success', {detail: data});
																generateForm.dispatchEvent(successEvent);
															}, function() {
																scheduleLoadMask.remove();
															});

														} else {
															//submit report
															var submitLoadMask = optionsWin.showLoading();
															Service.getReportService().submitReport(reportSubmission).then(function (data) {
																submitLoadMask.remove();
																
																window.DL.MessageUtil.showToast('Success', 'Submitted Report', {
																	theme: 'success'
																});
																closeOptionsDialog();
																var successEvent = new CustomEvent('success', {detail: data});
																generateForm.dispatchEvent(successEvent);
															}, function() {
																submitLoadMask.remove();
															});
														}
													}
												}
											} else {
												window.DL.MessageUtil.showToastError('Invalid form; check required options.');
											}
										}
									}
								}
							},
							{
								theme: 'tertiary',
								innerHTML: 'Cancel',
								style: 'margin-left: 10px;',
								listeners: {
									click: function() {
										closeOptionsDialog();
									}
								}
							}
						]
					}
				]
			});
		};
		
		var handleReportSelect = function(selectedReport) {
			generateForm.selectedReport = selectedReport;
			
			//Register Group call back; These should reset every selection
			generateForm.groupChangesCallbacks = [];
			generateForm.unitGroupId = generateForm.groupSelected ? generateForm.groupSelected.code : null;
			
			closeOptionsDialog();
			
			var thisOptionsWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: selectedReport.reportTypeDescription || 'Report Options',
				icon: 'vaadin:cogs',
				width: .75,
				height: .75,
				listeners: {
					beforeclose: function() {
						if (optionsWin === thisOptionsWin) {
							optionsWin = null;
						}
					},
					ready: function() {
						thisOptionsWin.show();
						
						reportContainer = ElementUtil.create({ 
							tag: 'div'
						});
						reportContainer.outputs = [];
						
						var reportDescription = ElementUtil.create({
							tag: 'div',
							style: 'text-align: center',
							trustedInnerHTML: true,
							innerHTML: '<h2>' + selectedReport.reportTypeDescription + '</h2>' + selectedReport.description				
						});
						reportContainer.append(reportDescription);			
						
						if (generateForm.options.closeReport) {
							var closeReportWarning = ElementUtil.create({
								tag: 'div',
								style: 'text-align: center',
								'class': 'alert alert-warning',
								trustedInnerHTML: true,
								innerHTML: '<i class="fas fa-exclamation-triangle warning-icon"></i>Report Date Range will be handled on the close report run'
							});
							reportContainer.append(closeReportWarning);
						}
						
						generateReportOptions(selectedReport);
						generateReportOutputs(selectedReport);
						
						var generalForm = ElementUtil.create({ 
							tag: 'dl-form-panel',
							itemid: 'generalForm',
							children: [
								{
									tag: 'vaadin-form-layout',
									itemid: 'generalForm-layout',
									children: [
										{
											tag: 'vaadin-text-field',
											maxlength: 255,
											colspan: '2',
											name: 'note',
											label: 'Note'
										}
									]
								}
							]
						});
						//scheduled options (if available)
						if (generateForm.scheduled) {
							generateScheduledOptions(generalForm, selectedReport);
						}						
						reportContainer.append(generalForm);
						reportContainer.append(createOptionButtons());
						
						thisOptionsWin.addToContentElement(reportContainer);
						
						setTimeout(function(){
							var scheduleMinutes = ElementUtil.query(generalForm, 'schedule-minutes');
							if (scheduleMinutes) {
								scheduleMinutes.classList.add('hide');
							}
							
							var scheduleCron = ElementUtil.query(generalForm, 'schedule-cron');
							if (scheduleCron) {
								scheduleCron.classList.add('hide');
							}
							
							var scheduleCronHelp = ElementUtil.query(generalForm, 'schedule-cron-help');
							if (scheduleCronHelp) {				
								scheduleCronHelp.classList.add('hide');
							}
						}, 100);
					}
				}
			});
			optionsWin = thisOptionsWin;
		};
		
		var generateScheduledOptions = function(generalForm, selectedReport) {
			
			var scheduledTypeCB = ElementUtil.create({ 
				tag: 'vaadin-combo-box',
				name: 'scheduleType',
				label: 'Schedule Interval',						
				required: true,
				'item-value-path': 'code',
				'item-label-path': 'description',
				postinit: function (combo) {
					var options = [];
					options.push({code: 'DAY', description: 'Daily'});
					options.push({code: 'W', description: 'Weekly'});
					options.push({code: 'M', description: 'Monthly'});
					options.push({code: 'Q', description: 'Quarterly'});
					options.push({code: 'Minutes', description: 'Custom Interval'});
					options.push({code: 'C', description: 'Complex'});					
					combo.items = options;																	
				},
				listeners: {
					change: function() {
						ElementUtil.query(generalForm, 'schedule-minutes').classList.add('hide');
						ElementUtil.query(generalForm, 'schedule-cron').classList.add('hide');
						ElementUtil.query(generalForm, 'schedule-cron-help').classList.add('hide');
						if (this.value === 'Minutes') {
							ElementUtil.query(generalForm, 'schedule-minutes').classList.remove('hide');
						}
						if (this.value === 'C') {
							ElementUtil.query(generalForm, 'schedule-cron').classList.remove('hide');						
							ElementUtil.query(generalForm, 'schedule-cron-help').classList.remove('hide');
						}
					}
				}
			});
			
			//number field for minutes
			var minutes = ElementUtil.create({ 
				tag: 'vaadin-number-field',
				itemid: 'schedule-minutes',
				name: 'minutes',
				label: 'Minutes',				
				min: 1,
				max: 99999				
			});
			
			//text field for cron  (validate)
			var cron = ElementUtil.create({ 
				tag: 'vaadin-text-field',
				itemid: 'schedule-cron',
				name: 'cron',
				label: 'Cron Expression',
				tooltip: 'test',
				properties: {
					originalLabel: 'Cron Expression'
				},
				listeners: {
					change: {
						fn: function() {
							
							//validate
							var cronModel = {
								expression: cron.value
							};
							
							Service.getReportService().validateCron(cronModel).then(function(result) {
								if (result.valid) {									
									cron.label = cron.label + ' (' + result.description + ')';
									cron.invalid = false;
									cron.errorMessage = '';
								} else {								
									cron.errorMessage = 'Cron Expression is Invaild.'; 
									cron.invalid = true;
									cron.label = cron.originalLabel;
								}
							});
							
						},
						buffer: 2000
					}
				}
			});
			var cronHelp = ElementUtil.create({ 
				tag: 'div',
				itemid: 'schedule-cron-help',
				colspan: 2,
				trustedInnerHTML: true,
				innerHTML: '<a href="https://www.freeformatter.com/cron-expression-generator-quartz.html" target="_blank">Cron Expression Help</a>'
			});
			
			var reportPeriodType = ElementUtil.create({ 
				tag: 'vaadin-combo-box',
				name: 'reportPeriodType',
				label: 'Report Period',
				'item-value-path': 'code',
				'item-label-path': 'description',
				value: 'DAYS',
				postinit: function (combo) {
					Service.getLookupService().getLookupValues('ReportPeriodType').then(function (data) {
						combo.items = data;						
						combo.required = true;
					});				
				}
			});
			
			var reportDaysInPast = ElementUtil.create({ 
				tag: 'vaadin-number-field',
				name: 'reportPeriodInPast',
				label: 'Report Period In Past (If applicable; blank = current period)',				
				'class': 'form-field-shift',
				min: 1,
				max: 2000
			});
			
			var generalLayout = ElementUtil.query(generalForm, 'generalForm-layout');
			
			generalLayout.append(scheduledTypeCB);
			generalLayout.append(minutes);
			generalLayout.append(cron);			
			generalLayout.append(cronHelp);
			generalLayout.append(reportPeriodType);
			generalLayout.append(reportDaysInPast);
			
		};
		
		var generateReportOptions = function(selectedReport) {
			
			var optionElements = optionsToFields(selectedReport.reportOptions);
			var hasUnitSelection = selectedReport.applicableReferenceTypes && selectedReport.applicableReferenceTypes.length > 0;
			if (optionElements.length > 0 || hasUnitSelection) {
				
				var groupId = null;
				var groupName = null;
				var unitSelectionType = 'FLEET';
				
				if (generateForm.groupSelected) {
					groupId = generateForm.groupSelected.code;
					groupName = generateForm.groupSelected.description;
					unitSelectionType = 'GROUP';
				}
				
				var optionsChildren = [
					{
						tag: 'legend',
						innerHTML: 'Options'
					}
				];
				
				if (hasUnitSelection) {
					optionsChildren.push({
						tag: 'dl-unitselection',
						itemId: 'unitSelection',
						companyId: generateForm.companyId,	
						selectionType: unitSelectionType,
						groupId: groupId,
						groupName: groupName,
						postinit: function(field) {
							field.referenceTypes = selectedReport.applicableReferenceTypes.join(',');
						},
						listeners: {
							'group-change': function(e) {	
								generateForm.unitGroupId = e.detail.unitGroupId;

								if (generateForm.groupChangesCallbacks) {
									generateForm.groupChangesCallbacks.forEach(function (groupCallback) {
										groupCallback(generateForm.unitGroupId);
									});
								}

								updateEmailOutputsForSelectedGroup(generateForm.unitGroupId);
							}
						}
					});
				}
				
				if (optionElements.length > 0) {
					optionsChildren.push({
						tag: 'dl-form-panel',
						itemid: 'reportOptionForm',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: optionElements
							}
						]
					});
				}
				
				var optionsContainer = ElementUtil.create({ 
					tag: 'fieldset',
					legend: 'Options',
					children: optionsChildren
				});
				reportContainer.append(optionsContainer);			
			}
		};


		var updateExistingEmailOutputs = function(emailAddress) {
			if (!reportContainer || !reportContainer.outputs) {
				return;
			}
			var addressValue = emailAddress || '';
			reportContainer.outputs.forEach(function(output) {
				if (output.transmissionType !== 'EMAIL') {
					return;
				}
				var outputForm = ElementUtil.query(reportContainer, 'reportOutputForm-' + output.outputId);
				if (!outputForm) {
					return;
				}
				var addressField = outputForm.querySelector('[name="address"]');
				if (addressField) {
					addressField.value = addressValue;
				}
			});
		};

		var updateEmailOutputsForSelectedGroup = function(unitGroupId) {
			if (!unitGroupId) {
				return;
			}
			Service.getReportService().getUnitGroupEmail(generateForm.companyId, unitGroupId).then(function(result) {
				var groupEmail = (result && result.email) ? result.email : '';
				updateExistingEmailOutputs(groupEmail);
			});
		};

		var generateReportOutputs = function(selectedReport) {
			
			var fileOutput = null;
			var menuItems = [];
			selectedReport.availableOutputs.forEach(function(output) {
				if (output.transmissionType === 'FILE') {
					 fileOutput = output;
				}
				menuItems.push({
					 tag: 'vaadin-item',
					 innerHTML: (output.transmissionType === 'FTP' ? 'FTP' : StringUtil.capitalizeFirstLetter(output.transmissionType.toLowerCase())),
					 properties: {
						 transmissionType: output.transmissionType,
						 output: output
					 },
					 listeners: {
						click: function(event) {
							addOutput(this.output);
						}
					}
				});
			});
			menuItems.sort(function(a, b){
				return a.properties.transmissionType.localeCompare(b.properties.transmissionType);
			});
						
			var outputContainer = ElementUtil.create({ 
				tag: 'fieldset',				
				children: [
					{
						tag: 'legend',
						innerHTML: 'Outputs'
					},
					{
						tag: 'dl-toolbar',						
						theme: 'spacing',			
						children: [
							{
								tag: 'dl-action-button',
								theme: 'primary',
								children: [
									{
										tag: 'span',
										innerHTML: 'Add'
									}
								],
								properties: {
									menu: menuItems	
								}						
							}
						]
					}
				]
			});			
			
			var addOutput = function(outputDefinition) {
				var output = Object.assign({}, outputDefinition);
				output.outputId = ElementUtil.nextId();
				if (outputDefinition.options) {
					output.options = outputDefinition.options.map(function(option) {
						return Object.assign({}, option);
					});
				}

				var buildOutputPanel = function() {
					var optionElements = [];
					//formats
					optionElements.push({
						tag: 'vaadin-combo-box',
						label: 'Format',
						name: 'format',
						required: true,
						'item-value-path': 'format',
						'item-label-path': 'formatDescription',
						postinit: function (combo) {
							combo.items = output.availableFormats;
							combo.value = output.availableFormats[0].format;
						},
						listeners: {
							change: function() {
								//find and clear format options
								var formatOptions = ElementUtil.query(outputElement, 'format-options-' + output.outputId);
								ElementUtil.removeAllChildren(formatOptions);
															
								//add new format options
								var optionOutputDefs = optionsToFields(this.selectedItem.options);
								optionOutputDefs.forEach(function(definition) {
									var optionElement = ElementUtil.create(definition);
									formatOptions.append(optionElement);
								});
							}
						}
					});
					 
					//options
					var optionOutputElements = optionsToFields(output.options);
					optionElements = optionElements.concat(optionOutputElements);
					
					var outputElement = ElementUtil.create({ 
						tag: 'dl-section-panel',
						title: StringUtil.capitalizeFirstLetter(output.transmissionType.toLowerCase()),
						closable: true,
						children: [												
							{
								tag: 'dl-form-panel',
								slot: 'content',
								itemid: 'reportOutputForm-' + output.outputId,
								children: [
									{
										tag: 'vaadin-form-layout',
										children: optionElements
									},
									{
										tag: 'vaadin-form-layout',
										itemid: 'format-options-' + output.outputId,
										children: []
									}
								]
							}
						],
						listeners: {
							close: function() {
								var closedOutputId = output.outputId;
								var newOutputs = [];
								reportContainer.outputs.forEach(function(o) {
									if (closedOutputId !== o.outputId) {
										newOutputs.push(o);
									}
								});
								reportContainer.outputs = newOutputs;
							}
						}
					});
					outputElement.output = output;
					outputContainer.append(outputElement);
					reportContainer.outputs.push(output);
				};

				if (output.transmissionType === 'EMAIL') {
					resolveDefaultEmailAddress().then(function(defaultEmail) {
						if (output.options) {
							output.options.forEach(function(option) {
								if (option.optionName === 'address') {
									option.defaultValueString = defaultEmail || '';
								}
							});
						}
						buildOutputPanel();
					});
				} else {
					buildOutputPanel();
				}
			};

			var resolveDefaultEmailAddress = function() {
				var userEmail = '';
				if (window.DL.currentUser && window.DL.currentUser.userProfile && window.DL.currentUser.userProfile.email) {
					userEmail = window.DL.currentUser.userProfile.email;
				}

				var unitGroupId = generateForm.unitGroupId;
				if (!unitGroupId && generateForm.groupSelected) {
					unitGroupId = generateForm.groupSelected.code;
				}

				if (!unitGroupId) {
					return Promise.resolve(userEmail);
				}

				return Service.getReportService().getUnitGroupEmail(generateForm.companyId, unitGroupId).then(function(result) {
					if (result && result.email) {
						return result.email;
					}
					return userEmail;
				}).catch(function() {
					return userEmail;
				});
			};
						
			if (fileOutput) {
				addOutput(fileOutput);
			}
											
						
			reportContainer.append(outputContainer);				
		};

		var optionsToFields = function(options) {
			var fields = [];
			options.forEach(function(option){
				var optionField;
				
				var namePrefix = '';
				if (option.dataType === 'Boolean') {
					optionField = {
						tag: 'vaadin-checkbox'						
					};
					if (option.defaultValueBoolean) {
						optionField.checked = true;
					}				
				} else if (option.dataType === 'Date') {
					//for scheduled report the dates are handle by the schedule
					if (!generateForm.scheduled) {
						optionField = {
							tag: 'vaadin-date-picker',							
							value: option.defaultValueDate ? TimeUtil.formatDateForDateLoadStriped(option.defaultValueDate) : null							
						};
					}
				} else if (option.dataType === 'List') {
					optionField = {
						tag: 'vaadin-combo-box',						
						'item-value-path': 'code',
						'item-label-path': 'description',
						value: option.defaultValueString,
						postinit: function (combo) {
							option.lookups.sort(function(a, b){
								return a.description.localeCompare(b.description);
							});
							combo.items = option.lookups;																	
						}						
					};
				} else if (option.dataType === 'String') {
					optionField = {
						tag: 'vaadin-text-field',
						value: option.defaultValueString ? option.defaultValueString : ''
					};
				} else if (option.dataType === 'BigDecimal' || option.dataType === 'Integer') {
					optionField = {
						tag: 'vaadin-number-field',
						value: option.defaultValueNumber != null ? option.defaultValueNumber : null
					};
				} else if (option.dataType === 'CompanyUnitGroups') {
					optionField = {
						tag: 'vaadin-combo-box',						
						'item-value-path': 'code',
						'item-label-path': 'description',
						value: option.defaultValueString,
						postinit: function (combo) {							
							Service.getReportService().getUnitGroupOption(generateForm.companyId).then(function(groupLookups){
								groupLookups.sort(function(a, b){
									return a.description.localeCompare(b.description);
								});
								combo.items = groupLookups;
							});															
						}	
					};
				} else if (option.dataType === 'DataFilter') {
					optionField = {
						tag: 'vaadin-combo-box',						
						'item-value-path': 'datafilterId',
						'item-label-path': 'name',						
						postinit: function (combo) {							
							Service.getReportService().getDataFilters(generateForm.companyId, option.defaultValueString).then(function(dataFilters){
								dataFilters.sort(function(a, b){
									return a.name.localeCompare(b.name);
								});
								combo.items = dataFilters;
							});															
						}	
					};
				} else if (option.dataType === 'YearMonthQuarter' || option.dataType === 'YearMonthQuarterCalendar') {
					optionField = {
						tag: 'dl-option-yearmonthquarter',
						value: option.defaultValueString
					};
					// Only set when true: ElementUtil setAttribute turns false into
					// calendarYears="false", which Lit Boolean treats as true.
					if (option.dataType === 'YearMonthQuarterCalendar') {
						optionField.calendarYears = true;
					}
					namePrefix = 'ymq_';
				} else if (option.dataType === 'YearMonthQuarterOrDateRange') {
					if (generateForm.scheduled) {
						// Schedules resolve period from schedule settings; keep month/quarter only.
						optionField = {
							tag: 'dl-option-yearmonthquarter',
							value: option.defaultValueString
						};
						namePrefix = 'ymq_';
					} else {
						optionField = {
							tag: 'dl-option-period-or-daterange',
							value: option.defaultValueString
						};
						namePrefix = 'period_';
					}
				} else if (option.dataType === 'YearQuarter') {
					optionField = {
						tag: 'dl-option-yearmonthquarter',
						hideMonth: true,
						value: option.defaultValueString
					};
					namePrefix = 'ymq_';
				} else if (option.dataType === 'MPGTypes') {								
					optionField = {
						tag: 'dl-mpgtype-selection',
						value: option.defaultValueString,
						postinit: function (mpgSelection) {							
							mpgSelection.updateMPGTargets(generateForm.companyId, generateForm.unitGroupId);
							
							generateForm.groupChangesCallbacks.push(function(unitGroup){
								mpgSelection.updateMPGTargets(generateForm.companyId, generateForm.unitGroupId);
							});							
						}
					};
					namePrefix = 'mpgtype_';
				} else if (option.dataType === 'HighlightFields') {
					optionField = {
						tag: 'dl-highlight-fields-selection',
						value: option.defaultValueString
					};
					namePrefix = 'highlight_';
				} else if (option.dataType === 'MeasurementSystem') {
					optionField = {
						tag: 'vaadin-combo-box',						
						'item-value-path': 'code',
						'item-label-path': 'description',
						value: option.defaultValueString,
						postinit: function (combo) {	
							Service.getReportService().getFueltaxPreference(generateForm.companyId, generateForm.unitGroupId).then(function(pref){								
								option.lookups.sort(function(a, b){
									return a.description.localeCompare(b.description);
								});	
								combo.items = option.lookups;
								combo.value = pref.reportDefaultUOM;
							});							
						}	
					};
				}
				
				if (optionField) {
					optionField.name = namePrefix + option.optionName;
					optionField.label = option.description;
					
					if (option.required) {
						optionField.required = true;
					}
					if (option.helperText) {
						optionField['helper-text'] = option.helperText;
					}
					
					fields.push(optionField);
				}
				
			});
			return fields;
		};
		
		
	}
	
	setCompanyId(companyId) {
		var generateForm = this;
		generateForm.companyId = companyId;
		if (generateForm.reloadReportSelection) {
			generateForm.reloadReportSelection();
		}
	}
			
}
customElements.define('dl-report-generate-form', GenerateReportForm);
